import { defineMessages } from 'react-intl';

export default defineMessages({
  error: { defaultMessage: 'Please input the correct amount' },
  continue: { defaultMessage: 'Continue' },
});
